import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';

import { useNavigate } from 'react-router-dom'

//var dateFormat = require('dateformat');



const RenderWpForm = () => {

const resturl=sessionStorage.getItem("RESTURL");

//var boolFetchingSads=false;

const navigate = useNavigate();
const navVsaummary = React.useRef();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});


const [renders, setRenders] = useState({count:0});
const [tblvsaverify, setTblvsaverify] = useState([]);
const [vsaapp, setVsaapp] = useState({VSA_APP_ID:0});

const [dowait, setDowait] = useState({on:false});

const [TOTAL_EMPTY_FIELDS, setTOTAL_EMPTY_FIELDS] = useState({NUM:500});



const location = useLocation();


useEffect(() => {

if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if

document.title =   "APS Submit Application";	

if (location.state.VSA_APP_ID!=null && location.state.VSA_APP_ID!=undefined && location.state.VSA_APP_ID!='null' && location.state.VSA_APP_ID!='undefined'){
	setVsaapp({VSA_APP_ID:location.state.VSA_APP_ID});
	}//end if
	//qrylabor();
 },[]);

useEffect(() => {

if (vsaapp.VSA_APP_ID>0 && tblvsaverify.length<1){
	gettblvsaverify();
	getvsaapp();
	}//end if
	//qrylabor();
 },[vsaapp]);


function getvsaapp(e){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {VSA_APP_ID:vsaapp.VSA_APP_ID} )
  };		

  fetch(resturl+'rarvsaform/getvsaapp',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetvsaapp(res) )
      .catch(err => console.log(err));

}//end func

function aftergetvsaapp(res){
if (res.length==undefined){
	if (res.error!=undefined)
		showsnackbar(res.error);
	return;
	}//end if
	

setVsaapp(res[0]);

}//end func






async function gettblvsaverify(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {VSA_APP_ID:vsaapp.VSA_APP_ID} )
  };		

 await fetch(resturl+'rarvsaform/gettblvsaverify',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergettblvsaverify(res) )
      .catch(err => console.log(err));

}//end func

function clickContinue(){
	
	
if (TOTAL_EMPTY_FIELDS.NUM>0){
	showsnackbar(TOTAL_EMPTY_FIELDS.NUM+' mandatory fields remain to be populated');
	return;
	}//end if	
else	
	navVsaummary.current?.click();
}//end func

function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func

function aftergettblvsaverify(res){
if (res.length==undefined)
	return;
	
console.log('aftergettblvsaverify, res.length: '+res.length);

let htmrows=[];
res.map((col, index) => {
	if (index==1)
		setTOTAL_EMPTY_FIELDS({NUM:col['TOTAL_EMPTY_FIELDS']});
	
	const SCTN=col['SCTN'];
	const SHORT_NAME=col['SHORT_NAME'];
	const NUM_FLD_RQD=col['NUM_FLD_RQD'];
	const NUM_DATA=col['NUM_DATA'];
	
	const MPT_FLD=col['MPT_FLD'];
	const trkey='tr_'+index;
	const tdkey='td_'+index;
	const rdkey='td_'+index;
	const ok=(NUM_FLD_RQD>NUM_DATA)?<img src='img/alert.png' height='18' border='0' />:<img src='img/greentick.png' height='18' border='0' />
	
	const htmrow=<tr key={trkey} >
	<td align='left' key={tdkey} className="hand"  onClick={(e)=>{navigate('/vsaform',{state:{VSA_APP_ID:vsaapp.VSA_APP_ID,SCTN:SCTN}});}} >{1+index}:&nbsp;{SHORT_NAME}</td>
	<td align='center' key={'c3'+tdkey}  >{NUM_FLD_RQD}</td>
	<td align='center' key={'c4'+tdkey}  >{NUM_DATA}</td>
	<td align='center' key={'c5'+tdkey}  >{ok}</td>
	<td align='left' key={'c6'+tdkey}  >{MPT_FLD}</td>
	</tr>;
	htmrows.push(htmrow);
});

setTblvsaverify(htmrows);
}//end func


	
  return (
    <>
	<p align='center' >Please verify below that all mandatory input fields are populated<br/>before submitting your Visa Applicaiton</p>
	<table align='center'>
	<tbody>
	<tr>
	<td align='right' >Applicaiton Ref #: </td>
	<td align='left' >{vsaapp.REF_NUM}</td>
	</tr>
	<tr>
	<td align='right' >Surety's Name: </td>
	<td align='left' >{vsaapp.STY_GVN_NAM+" "+vsaapp.STY_SUR_NAM}</td>
	</tr>
	<tr>
	<td align='right' >Applicant: </td>
	<td align='left' >{vsaapp.VSR_GVN_NAM+" "+vsaapp.VSR_SUR_NAM}</td>
	</tr>
	
	</tbody>
	</table>
	
	<table align='center' className='customers' style={{width:"65%"}} >
	<thead>
	<tr>
		<th>section:<br/>click the section to<br/>return to application</th>
		<th># of mandatory<br/>input fields</th>
		<th># of populated<br/>input fields</th>
		<th>verify<br/>Ok</th>
		<th>name of unpopulated input field</th>
	</tr>
	</thead>
	<tbody>
		{tblvsaverify}
	</tbody>
	</table>

<p align='center' >  

        <NavLink ref={navVsaummary} to={"/vsasummary"} style={{display:"none"}}
          state={{VSA_APP_ID:vsaapp.VSA_APP_ID}}  >vsasummary</NavLink>
		
        <NavLink to={"/vsaform"} state={{VSA_APP_ID:vsaapp.VSA_APP_ID}} >return to application form</NavLink>
		&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
		
		{dowait.on && <div><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</div>}
		{
		!dowait.on && 
		<input type="button" id='btnsubmitapp' className="button" value="application summary review and submit" onClick={(e)=>{ e.preventDefault(); clickContinue(); }}  />
		
		}
</p>  

<div id="snackbar">&nbsp;</div>
    </>
  );
  


};


export default RenderWpForm;